import { z } from "zod";
import { isNameValid, isCPFValid } from "@/utils/FormValidators";

export function buildAccountUpdateSchema(phoneMaskLength: number) {
  return z.object({
    name: z
      .string()
      .min(3, "Informe um nome válido")
      .refine(isNameValid, "Informe um nome válido"),
    document_number: z
      .string()
      .min(1, "Informe um CPF válido")
      .refine(isCPFValid, "Informe um CPF válido"),
    country_code: z.string().min(1, "Informe o DDI"),
    phone: z
      .string()
      .min(1, "Informe um telefone válido")
      .refine(
        (v) => v.length >= phoneMaskLength,
        "Informe um telefone válido",
      ),
  });
}
export type AccountUpdateValues = z.infer<
  ReturnType<typeof buildAccountUpdateSchema>
>;

export const passwordUpdateSchema = z
  .object({
    old_password: z
      .string()
      .min(8, "Informe uma senha com no mínimo 8 caractéres"),
    password: z
      .string()
      .min(8, "Informe uma senha com no mínimo 8 caractéres"),
    passwordConfirmation: z.string().min(1, "As senhas não correspondem"),
  })
  .superRefine((data, ctx) => {
    if (data.passwordConfirmation !== data.password) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["passwordConfirmation"],
        message: "As senhas não correspondem",
      });
    }
  });
export type PasswordUpdateValues = z.infer<typeof passwordUpdateSchema>;
